'use client';

import React, { FC } from 'react';

import { ShopifyVariant } from '@/lib/shopify';

import { useFlags } from 'launchdarkly-react-client-sdk';
import useTailwind from '@/hooks/useTailwind';
import { getProductTariff } from '@/components/subflow-v3/components/PlayKitDetailsHeader/utils';
import { ToolTip } from '@/components/ui/ToolTip';
import interpolate from '@/utils/translations/interpolate';
import { TypeProduct, TypeProductFields } from '@/core/generated-types';
import { mapTitleToAnchor } from '@/components/subflow-v3/components/utils';
import { TypeTariffSettings } from '../types';
import classNames from 'classnames';

export interface TariffPDPMessageProps {
  product?: TypeProduct;
  tariffSettings?: TypeTariffSettings;
  alignTextLeft?: boolean;
}

export interface SelectedAddOns {
  fields: TypeProductFields;
  variant: ShopifyVariant;
}

const TariffPDPMessage: FC<TariffPDPMessageProps> = ({
  product,
  tariffSettings,
  alignTextLeft,
}) => {
  const tw = useTailwind();

  const { 'sub-squad-enable-tariff': subSquadEnableTariff } = useFlags();

  const anchor = product?.fields.isPlayKit
    ? mapTitleToAnchor(product?.fields.title || '')
    : product?.fields.shopifyProduct?.handle;

  const isExcluded = anchor && tariffSettings?.exclusionList.includes(anchor);

  const tariffValue = product && getProductTariff(product);

  if (!subSquadEnableTariff || isExcluded || !tariffValue) return null;
  return (
    <div
      className={classNames('flex items-center  gap-2 mt-3', {
        'justify-center': !alignTextLeft,
        'justify-start': alignTextLeft,
      })}
    >
      <p className="text-sm md:text-base">
        {tariffSettings?.translations?.tariffMessage}
      </p>
      <ToolTip
        color={tw.colors.blue.deep}
        classes="text-sm lg:text-base"
        tooltipClassName="max-w-[320px] lg:max-w-auto"
        width={17}
        height={17}
        id="tooltip"
        message={interpolate(
          tariffSettings?.translations?.tariffTooltip || '',
          {
            value: String(tariffValue),
          },
        )}
      />
    </div>
  );
};

export default TariffPDPMessage;
